import { render, staticRenderFns } from "./goals.vue?vue&type=template&id=54dd101c&scoped=true"
import script from "./goals.vue?vue&type=script&lang=js"
export * from "./goals.vue?vue&type=script&lang=js"
import style0 from "./goals.vue?vue&type=style&index=0&id=54dd101c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54dd101c",
  null
  
)

export default component.exports